import React, { useEffect, useRef, useState } from "react";
import NcImage from "components/NcImage/NcImage";
import SingleHeader from "app/(singles)/SingleHeader";
import { Link, useParams } from "react-router-dom";
import { BACKEND_URL } from "constants";
import SectionSliderCards from "components/Sections/SectionSliderCard";

const PageSingle = () => {
  const params = useParams();

  const [data, setData] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(true)
  const [articles, setArticles] = useState([]);
  const [adverts, setAdverts] = useState([]);

  useEffect(() => {
  const fetchArticle = async () => {
    try {
      setLoading(true);

      const res = await fetch(
        `${BACKEND_URL}/article/${Number(params.id)}`
      );

      const dataFetched = await res.json();

      if (!dataFetched.hasOwnProperty("error")) {
        setData(
          Array.isArray(dataFetched)
            ? dataFetched
            : [dataFetched]
        );
      }
    } catch (err) {
      console.error("Error fetching article:", err);
    } finally {
      setLoading(false);
    }
  };

  if (params.id) {
    fetchArticle();
  }
}, [params.id]);

  useEffect(() => {
  if (!params.id) return;

  fetch(`${BACKEND_URL}/relatedArticles/${params.id}`)
    .then((res) => {
      if (!res.ok) {
        throw new Error("Błąd pobierania podobnych artykułów");
      }
      return res.json();
    })
    .then((res) => {
      setArticles(Array.isArray(res) ? res : []);
    })
    .catch((err) => {
      console.error("Błąd podobnych artykułów:", err);
    });
}, [params.id]);


  useEffect(() => {
    fetch(`${BACKEND_URL}/get-adverts`)
      .then((res) => res.json())
      .then((res) => {
        if (!res.hasOwnProperty("error")) {
          setAdverts(res);
          setLoading(false)
        }
      })
      .catch((err) =>
        console.error("error: ", err)
      );
  }, []);

  // 📖 Czas czytania
  const plainText = (
    data[0]?.long_description || ""
  ).replace(/<[^>]+>/g, " ");

  const wordsCount = plainText
    .split(/\s+/)
    .filter(Boolean).length;

  const readingTime = Math.ceil(
    wordsCount / 200
  );

  const galleryImages = (() => {
  const gallery = data[0]?.gallery_images;

  if (Array.isArray(gallery)) {
    return gallery;
  }

  if (typeof gallery === "string") {
    try {
      const parsed = JSON.parse(gallery);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  return [];
})();
  
  return (

  <div
  className="nc-PageSingle pt-8 lg:pt-16"
  style={{
    display: "flex",
    flexFlow: "column",
    alignItems: "baseline",
  }}
>
  <header className="container single-responsive">
    <SingleHeader data={data} />
  </header>

  {/* GŁÓWNY UKŁAD */}
  <div className="container single-layout">

    {/* LEWA STRONA */}
    <div className="article-column">

      {/* Pierwszy opis */}
<div
  className="article-content"
  dangerouslySetInnerHTML={{
    __html: data[0]?.long_description || "",
  }}
/>
      <div className="media-block">
        {data[0]?.type === "image" && data[0]?.image && (
          <NcImage
            alt="image"
            className="w-full image-resp"
            src={data[0].image}
            width={1000}
            height={900}
            sizes="(max-width: 1024px) 100vw, 1280px"
          />
        )}

        {/* Drugi opis — niezależne pole */}
{data[0]?.second_description?.trim() && (
  <div
    className="article-content second-description"
    dangerouslySetInnerHTML={{
      __html: data[0].second_description,
    }}
  />
)}

         {galleryImages.length > 0 && (
        <section className="article-gallery">
          <div className="gallery-grid">
            {galleryImages.map((image, index) => (
              <button
                key={`${image}-${index}`}
                type="button"
                className="gallery-item"
                onClick={() => setSelectedImage(image)}
                aria-label={`Powiększ zdjęcie ${index + 1}`}
              >
                <img
                  src={image}
                  alt={`Zdjęcie galerii ${index + 1}`}
                  loading="lazy"
                />
              </button>
            ))}
          </div>
        </section>
      )}

      {/* POWIĘKSZENIE ZDJĘCIA */}
      {selectedImage && (
        <div
          className="gallery-lightbox"
          onClick={() => setSelectedImage(null)}
          role="dialog"
          aria-modal="true"
          aria-label="Powiększone zdjęcie"
        >
          <button
            type="button"
            className="gallery-close"
            onClick={() => setSelectedImage(null)}
            aria-label="Zamknij zdjęcie"
          >
            &times;
          </button>

          <img
            src={selectedImage}
            alt="Powiększone zdjęcie z galerii"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

        {data[0]?.type === "wideo" && (
          <video
            src={data[0]?.video}
            poster={data[0]?.image}
            controls
            width={1000}
            height={900}
          />
        )}

        {data[0]?.date && (
          <span className="meta">
            {new Date(data[0].date).toLocaleString()}
          </span>
        )}

        {wordsCount > 0 && (
          <span className="meta">
            Szacowany czas czytania:{" "}
            <b>{readingTime} min</b>
          </span>
        )}
      </div>
    </div>

    {/* PRAWA STRONA - 2 REKLAMY */}
    {loading ? <span>Wczytywanie reklam...</span> : <aside className="ads-column">

      {/* górna reklama */}
      <Link to={adverts[14]?.link}>
       <img
  src={adverts[14]?.photo}
  loading="eager"
  fetchPriority="high"
  alt="Reklama"
  className="ad-banner"
/>
      </Link>

      {/* “rozpychacz” żeby druga reklama kończyła się niżej */}
      {/* <div className="ad-spacer" /> */}

      {/* dolna reklama */}
      <Link to={adverts[15]?.link}>
        <img
         src={adverts[15]?.photo}
          alt="Reklama"
          className="ad-banner"
        />
      </Link>

    </aside>}

  </div>

  {/* ZOBACZ TEŻ */}
  <div className="container">
    <SectionSliderCards
      className="py-16"
      postCardName="card10"
      heading="Zobacz też"
      subHeading="Inne Artykuły"
      posts={articles}
    />
  </div>

  <style jsx>{`

    .article-gallery {
      margin-top: 36px;
      width: 100%;
    }


    .gallery-title {
    font-size: 26px;
    font-weight: 700;
    margin-bottom: 20px;
    font-family: Lato, sans-serif;
    }

    .gallery-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
    }

    .gallery-item {
    display: block;
    width: 100%;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
    overflow: hidden;
    aspect-ratio: 4 / 3;
    }

    .gallery-item img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.25s ease;
    }

    .gallery-item:hover img {
    transform: scale(1.04);
    }

    .gallery-lightbox {
    position: fixed;
    inset: 0;
    z-index: 99999;
    background: rgba(0, 0, 0, 0.92);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 50px 20px 20px;
    cursor: zoom-out;
    }

    .gallery-lightbox > img {
    max-width: 100%;
    max-height: 90vh;
    width: auto;
    height: auto;
    object-fit: contain;
    }

    .gallery-close {
    position: absolute;
    top: 12px;
    right: 24px;
    color: white;
    font-size: 42px;
    border: none;
    background: transparent;
    cursor: pointer;
    line-height: 1;
    }

    @media (max-width: 640px) {
    .gallery-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    }

    .gallery-title {
    font-size: 22px;
    }
    }

    .single-layout {
      display: flex;
      gap: 40px;
      align-items: stretch; /* KLUCZ */
    }

    .article-column {
      flex: 1;
      min-width: 0;
    }

    .article-content{
      font-family:Lato!important;
      font-size:22px;
    }

    .ads-column {
      width: 320px;
      display: flex;
      flex-direction: column;
      gap: 24px;
      position: sticky;
      top: 100px;
      height: fit-content;
    }

    .ad-banner {
      width: 100%;
      border-radius: 12px;
      display: block;
    }

    .ad-spacer {
      flex: 1; /* to robi “rozciągnięcie” między reklamami */
    }

    .media-block {
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

    .meta {
      color: grey;
      font-weight: 700;
    }

    @media (max-width: 1024px) {
      .single-layout {
        flex-direction: column;
      }

      .ads-column {
        width: 100%;
      }

      .ad-spacer {
        display: none;
      }
    }
  `}</style>
</div>
);

};

export default PageSingle;